import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-02fd74f0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "fill" }

import ClickAwayHandler from "./ClickAwayHandler.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'Tray',
  props: {
    prefer: null
  },
  setup(__props: any) {

const props = __props as {
	prefer: "top" | "bottom" | "left" | "right";
}



// TODO: We should make this component detect if it would run off the screen and adjust it's positioning accordingly.
// This might help https://stackoverflow.com/questions/11512032/detect-if-dropdown-navigation-would-go-off-screen-and-reposition-it

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ClickAwayHandler, {
    class: _normalizeClass(["absolute rounded-1 bg-1 b-1", props.prefer]),
    onClickedAway: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked-away')))
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["class"]))
}
}

})